/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_sg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A slug is the readable part of a URL that identifies a page, like "my-blog-post" in /blog/my-blog-post. It's usually derived from the page title and appears after the last slash. Clean slugs are easier for people to read and share, and they give search engines an extra signal about what the page covers.`)
};

const es_sg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un slug es la parte legible de una URL que identifica una página, como "mi-publicación-de-blog" en /blog/mi-publicación-de-blog. Generalmente se deriva del título de la página y aparece después de la última barra. Los slugs limpios son más fáciles de leer y compartir para las personas, y dan a los motores de búsqueda una señal adicional sobre qué trata la página.`)
};

const de_sg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein Slug ist der lesbare Teil einer URL, der eine Seite identifiziert, wie "my-blog-post" in /blog/my-blog-post. Er wird normalerweise vom Seitentitel abgeleitet und erscheint nach dem letzten Schrägstrich. Saubere Slugs sind leichter für Menschen zu lesen und zu teilen, und sie geben Suchmaschinen ein zusätzliches Signal darüber, worum es auf der Seite geht.`)
};

const nl_sg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een slug is het leesbare deel van een URL dat een pagina identificeert, zoals "my-blog-post" in /blog/my-blog-post. Het wordt meestal afgeleid van de paginatitel en verschijnt na de laatste schuine streep. Schone slugs zijn gemakkelijker voor mensen om te lezen en te delen, en ze geven zoekmachines een extra signaal over wat de pagina behandelt.`)
};

const fr_sg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Un slug est la partie lisible d'une URL qui identifie une page, comme "my-blog-post" dans /blog/my-blog-post. Il est généralement dérivé du titre de la page et apparaît après la dernière barre oblique. Les slugs propres sont plus faciles à lire et partager, et ils donnent aux moteurs de recherche un signal supplémentaire sur ce que couvre la page.`)
};

const it_sg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uno slug è la parte leggibile di un URL che identifica una pagina, come "my-blog-post" in /blog/my-blog-post. È solitamente derivato dal titolo della pagina e appare dopo l'ultimo slash. Gli slug puliti sono più facili da leggere e condividere per le persone, e danno ai motori di ricerca un segnale extra su ciò che la pagina copre.`)
};

const pt_br2_sg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um slug é a parte legível de uma URL que identifica uma página, como "meu-post-blog" em /blog/meu-post-blog. É geralmente derivado do título da página e aparece após a última barra. Slugs limpos são mais fáceis para as pessoas lerem e compartilharem, e eles fornecem um sinal extra aos mecanismos de busca sobre o que a página cobre.`)
};

const pt_sg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um slug é a parte legível de um URL que identifica uma página, como "my-blog-post" em /blog/my-blog-post. É normalmente derivado do título da página e aparece após a última barra. Slugs limpos são mais fáceis de ler e partilhar, e dão aos motores de busca um sinal extra sobre o que a página cobre.`)
};

const ja_sg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スラグは /blog/my-blog-post の "my-blog-post" のように、ページを識別するURLの読みやすい部分です。通常はページのタイトルから派生し、最後のスラッシュの後に表示されます。クリーンなスラグは人が読んで共有しやすく、ページが何についているかについて検索エンジンに追加のシグナルを提供します。`)
};

const zh_sg_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`slug 是 URL 中用于标识页面的可读部分，例如 /blog/my-blog-post 中的“my-blog-post”。它通常来源于页面标题，出现在最后一个斜杠之后。简洁的 slug 更便于用户阅读和分享，也能为搜索引擎提供关于页面内容的额外信号。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const sg_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.sg_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("sg_faq1_a", locale)
	if (locale === "en") return en_sg_faq1_a(inputs)
	if (locale === "es") return es_sg_faq1_a(inputs)
	if (locale === "de") return de_sg_faq1_a(inputs)
	if (locale === "nl") return nl_sg_faq1_a(inputs)
	if (locale === "fr") return fr_sg_faq1_a(inputs)
	if (locale === "it") return it_sg_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_sg_faq1_a(inputs)
	if (locale === "pt") return pt_sg_faq1_a(inputs)
	if (locale === "ja") return ja_sg_faq1_a(inputs)
	return zh_sg_faq1_a(inputs)
};